type Props = {
	title: string;
	children: React.ReactNode; //
};

/**
 * 料金プラン設定画面の、Island内で共通で使用するセクションコンポーネント
 * １つのセクション毎にこのコンポーネントを使用する
 */
export const SettingsBillingSection = ({ title, children }: Props) => {
	return (
		<div className="space-y-4">
			<p>{title}</p>

			<div className="ml-0 grid grid-cols-1 gap-y-2 tablet:ml-4 tablet:grid-cols-4 tablet:gap-x-2 tablet:gap-y-0">
				{children}
			</div>
		</div>
	);
};

SettingsBillingSection.displayName = "SettingsBillingSection";
